import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Spotpris = lazy(() => import("@/pages/spotpris/Spotpris"));

export const Route = createFileRoute("/spotpris/")({
  head: () => seoHead("/spotpris", { description: "Spotpriset är marknadspriset på el som sätts varje timme av Nord Pool. Här ser du aktuella spotpriser per elområde och förklaringar till hur det fungerar." }),
  component: () => <Spotpris />,
});
